document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.sidebar-search-wrapper .filter-group-wrapper .filter-toggle').forEach(btn => {
    btn.addEventListener('click', function () {
      const list = this.nextElementSibling;
      list.classList.toggle('open');
      this.classList.toggle('open');
    });
  });
});